// eslint-disable-next-line @stencil-community/ban-exported-const-enums
export enum MobileFilteringAreaType {
  Chips= 'chips'
}
